<template>
    <footer class="bg-neutral-900 text-white">

        <div class="max-w-screen-lg mx-auto p-10 md:p-20">

            <div class="max-w-screen-md mb-10">
                <h2 class="text-2xl font-bold mb-4">
                    😈 <span class="ml-1">{{ appName }}</span>
                </h2>
                <p class="text-neutral-400">
                    Explore your desires with a modern kink & BDSM test. Discover your preferences, boundaries, and
                    fantasies in a safe, consensual way.
                </p>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div v-for="page in pages" :key="page.id">
                    <h3 class="text-lg font-semibold">
                        <a :href="page.route" class="text-white hover:text-neutral-400 transition-colors">
                            {{ page.title }}
                        </a>
                    </h3>
                    <ul>
                        <li v-for="child in page.children" :key="child.id">
                            <a :href="child.route" class="text-neutral-400 hover:text-white transition-colors text-sm line-clamp-1">
                                {{ child.title }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="mt-12 pt-8 border-t border-neutral-800">
                <!-- Social Links -->
                <div class="flex justify-center space-x-6 mb-6">
                    <a v-for="social in socials" 
                       :key="social.name"
                       :href="social.url" 
                       target="_blank" 
                       rel="noopener noreferrer" 
                       class="text-neutral-400 hover:text-white transition-colors">
                        <i :class="social.icon" class="text-xl"></i>
                        <span class="sr-only">{{ social.name }}</span>
                    </a>
                </div>

                <p class="text-neutral-400 text-sm text-center cursor-pointer">
                    © ModernKink.co &middot; All Rights Reserved &middot;
                    <span @click="launchFeedbackModal">
                        Feedback
                    </span>
                    &middot; v{{ version }}
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import {ref} from 'vue'

export default {
    name: 'Foot',
    setup() {
        const pages = (window.app.pages || []).map((page) => {
            page.childen = (page.children || []).sort((a, b) => a.title > b.title ? 1 : -1);
            return page;
        });
        const appName = ref(window.app.name || 'ModernKink.co')
        const version = ref(window.app.version || '')
        const launchFeedbackModal = () => {
            window.app.emit('openFeedbackModal')
        };

        const socials = [
            {
                name: 'Twitter',
                url: 'https://twitter.com/modernkinkco',
                icon: 'fab fa-twitter'
            },
            {
                name: 'Instagram',
                url: 'https://instagram.com/modernkinkco',
                icon: 'fab fa-instagram'
            },
            {
                name: 'Tumblr',
                url: 'https://tumblr.com/modernkinkco',
                icon: 'fab fa-tumblr'
            }
        ];

        return {
            appName,
            launchFeedbackModal,
            pages,
            version,
            socials,
        }
    }
}
</script>

<style scoped lang="scss">

</style>
